/* eslint-disable import/extensions */
/* eslint-disable import/order */
/* eslint no-use-before-define: 0 */
import React from "react";
import { useFocused, useSelected, useSlateStatic } from "slate-react";

import { removeLink } from "../../utils/link.js";
import unlink from "../../Toolbar/toolbarIcons/unlink.svg";
// eslint-disable-next-line import/newline-after-import
import "./styles.css";
const Link = ({ attributes, element, children }) => {
  const editor = useSlateStatic();
  const selected = useSelected();
  const focused = useFocused();
  return (
    <div className="link">
      <a
        href={element.href}
        {...attributes}
        {...element.attr}
        target={element.target}
      >
        {children}
      </a>
      {selected && focused && (
        <div className="link-popup" contentEditable={false}>
          <a href={element.href} target={element.target}>
            {element.href}
          </a>
          <button onClick={() => removeLink(editor)}>
            <img className="Richimg" src={unlink} alt="" />
          </button>
        </div>
      )}
    </div>
  );
};

export default Link;
